import { Box, Button, ButtonExtendedProps, Text } from 'grommet'

import useDeviceSize from 'hooks/useDevice'
import { BasicEmotion, Emotion } from 'db-tables'

import EmotionName from './EmotionName'
import { emotionDropProps } from './tooltip'
import EmotionDescription from './EmotionDescription'

type Props = {
  emotion: BasicEmotion | Emotion
  selected: boolean
} & ButtonExtendedProps
export default function EmotionButton({ emotion, disabled, selected, ...rest }: Props) {
  const { small } = useDeviceSize()
  const size = small ? 'large' : 'small'
  return (
    <Button
      primary
      size={size}
      key={emotion.id}
      color={selected ? 'brand' : 'white'}
      disabled={selected ? false : disabled}
      label={
        <Text size={size}>
          <EmotionName emotion={emotion} />
        </Text>
      }
      tip={{
        plain: true,
        dropProps: emotionDropProps,
        content: (
          <Box width={{ max: 'medium' }} margin="small">
            <Text size="small" textAlign="start">
              <EmotionDescription emotion={emotion} />
            </Text>
          </Box>
        ),
      }}
      {...rest}
    />
  )
}
